import React from "react";
import PropTypes from "prop-types";

function tatColorClass(minutes) {
    if (minutes === null || minutes === undefined) return "bg-gray-200";
    if (minutes < 360)  return "bg-[#28A48B]";
    if (minutes < 1440) return "bg-yellow-400";
    return "bg-red-400";
}

function tatTextClass(minutes) {
    if (minutes === null || minutes === undefined) return "text-gray-400";
    if (minutes < 360)  return "text-[#28A48B]";
    if (minutes < 1440) return "text-yellow-600";
    return "text-red-500";
}

function fmtMinutes(minutes) {
    const d = Math.floor(minutes / 1440);
    const h = Math.floor((minutes % 1440) / 60);
    const m = minutes % 60;
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
}

function TATBar({ minutes, max, pending }) {
    if (minutes === null || minutes === undefined || max === 0) {
        return <span className="text-gray-400 text-sm">—</span>;
    }

    const pct = Math.min((minutes / max) * 100, 100);
    const label = fmtMinutes(minutes);

    return (
        <div className="flex items-center gap-2 min-w-[140px]">
            <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                <div
                    className={`h-full rounded-full ${tatColorClass(minutes)} ${pending ? "opacity-50" : ""}`}
                    style={{ width: `${pct}%` }}
                />
            </div>
            <span className={`text-xs font-semibold font-mono text-right ${tatTextClass(minutes)}`} style={{ minWidth: 52 }}>
                {label}
                {pending && <span className="ml-1 text-gray-400 font-normal">…</span>}
            </span>
        </div>
    );
}

TATBar.propTypes = {
    minutes: PropTypes.number,
    max:     PropTypes.number.isRequired,
    pending: PropTypes.bool,
};

export default TATBar;
